
import React from "react";
import { useTranslation } from "react-i18next";
import { MessageSquare, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SocialGroupType } from "@/types/social-groups";

interface DeleteGroupDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  group: SocialGroupType | null;
  onDelete: () => void;
  isRTL: boolean;
}

export const DeleteGroupDialog: React.FC<DeleteGroupDialogProps> = ({
  isOpen,
  setIsOpen,
  group,
  onDelete,
  isRTL,
}) => {
  const { t } = useTranslation();

  if (!group) return null;

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[450px]">
        <DialogHeader>
          <DialogTitle className="text-destructive">
            {isRTL ? "تأكيد الحذف" : "Confirm Deletion"}
          </DialogTitle>
          <DialogDescription>
            {isRTL
              ? "هل أنت متأكد من رغبتك في حذف هذه المجموعة؟ هذا الإجراء لا يمكن التراجع عنه."
              : "Are you sure you want to delete this group? This action cannot be undone."}
          </DialogDescription>
        </DialogHeader>
        
        <div className="border rounded-lg p-4 my-4">
          <div className="font-medium text-lg mb-2">
            {group.name[isRTL ? "ar" : "en"]}
          </div>
          <div className="text-muted-foreground">
            {group.description[isRTL ? "ar" : "en"]}
          </div>
          <div className="mt-2 flex items-center gap-2">
            {group.type === "whatsapp" ? (
              <>
                <MessageSquare size={16} className="text-green-500" />
                <span>{isRTL ? "واتساب" : "WhatsApp"}</span>
              </>
            ) : (
              <>
                <Send size={16} className="text-blue-500" />
                <span>{isRTL ? "تلجرام" : "Telegram"}</span>
              </>
            )}
            <span className="mx-2">•</span>
            <span>
              {group.members.toLocaleString()} {isRTL ? "عضو" : "members"}
            </span>
          </div>
        </div>
        
        <DialogFooter className="flex items-center gap-2 justify-end">
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            {isRTL ? "إلغاء" : "Cancel"}
          </Button>
          <Button variant="destructive" onClick={onDelete}>
            {isRTL ? "حذف" : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
